import React, {useState} from "react";
import {Tooltip} from "@mui/material";
import Box from "@mui/material/Box";

export function CreditsIcon(props: {sx? :any, title?: string, color?:string}){
    const [src, setSrc] = useState(
        `https://res.cloudinary.com/xenesis/image/upload/c_scale,h_${15},w_${15},co_rgb:${props.color ? props.color : '000000'},e_colorize:${props.color ? 50 : 0}/valWebp/CREDITS.webp`
    );


    return <Tooltip title={props.title ? props.title : 'Credits'} followCursor={true}>
        <Box
                component={"img"}
                src={src}
                sx={props.sx}
            />
        </Tooltip>
}